export default function Conditional(props) {
  if (props.show === true) {
    return props.children;
  }
  return null;
}